module.exports = __webpack_public_path__ + "img/plus.17a5c9c9.png";